module.exports = __webpack_public_path__ + "img/list.67eac8c9.svg";